<template>
<div class="Wrapper Proposal">
	<transition name="fade">
		<Preloader v-if="isLoading" />
	</transition>
	<div class="Navigation">
		<div @click="backToBuilder" class="Button-Third">
			<span>Back to Builder</span>
			<svg viewBox="0 0 129 129">
				<path d="m88.6,121.3c0.8,0.8 1.8,1.2 2.9,1.2s2.1-0.4 2.9-1.2c1.6-1.6 1.6-4.2 0-5.8l-51-51 51-51c1.6-1.6 1.6-4.2 0-5.8s-4.2-1.6-5.8,0l-54,53.9c-1.6,1.6-1.6,4.2 0,5.8l54,53.9z"/>
			</svg>
		</div>
		<div class="">
			<div @click="printPage" class="Button">
				<span>Print as PDF</span>
			</div>
			<div @click="toggleButton" class="Button" :class='[
                {"Button--Blue":proposal["Status"] === "draft"},
                {"Button--Orange":proposal["Status"] === "pending"},
                {"Button--Green":proposal["Status"] === "accepted"},
                {"Button--Purple":proposal["Status"] === "updated"},
                {"Button--Red":proposal["Status"] === "rejected"}
                ]'>
				<span v-if='proposal["Status"] === "draft"'>draft</span>
				<span v-if='proposal["Status"] === "pending"'>pending</span>
				<span v-if='proposal["Status"] === "rejected"'>rejected</span>
                <span v-if='proposal["Status"] === "updated"'>updated</span>
				<span v-if='proposal["Status"] === "accepted"'>accepted</span>
			</div>
		</div>
	</div>
	<CoverPage :projectInfo="proposal" :company="resolvedCompany" :logoPosition="proposal['Logo-Position'] || 'left'"></CoverPage>
	<Milestones :proposal="proposal"></Milestones>
	<ConfirmationPage :company="resolvedCompany" :logoPosition="proposal['Logo-Position'] || 'left'" :projectConfirmation="proposal['Project-Confirmation']" :projectNumber="proposal['Project-Number']" :projectDate="proposal['Date']" :projectType="proposal['Type']"></ConfirmationPage>
</div>
</template>

<script>
import CoverPage from '../components/page/CoverPage.vue';
import Milestones from '../components/page/Milestones.vue';
import ConfirmationPage from '../components/page/ConfirmationPage.vue';
import Preloader from '../components/page/Preloader.vue';

import router from '../router';
import { func } from '../mixins/functions';
import { mapGetters } from 'vuex';

export default {
	name: 'Proposal',
	mixins: [func],
	props: {

	},
	components: {
		CoverPage,
		Milestones,
		ConfirmationPage,
		Preloader
	},
	data() {
		return {
			projectConfirmation: {},
			pageNum: 0,
			isLoading: true,
		}
	},
	created() {
		this.$store.dispatch('getAllCompanies');
	},
	watch: {

	},
	computed: {
		...mapGetters({
			proposal: 'proposal',
			companies: 'companies',
			mainCompany: 'mainCompany',
		}),
		currentCompany() {
			if (!this.proposal || !this.proposal['company-id'] || !this.companies.length) return null;
			return this.companies.find(c => c.id === this.proposal['company-id']) || null;
		},
		resolvedCompany() {
			const c = this.currentCompany;
			const m = this.mainCompany;
			if (!c && !m) return null;
			if (!m || c === m) return c;
			if (!c) return m;
			const addr = (c.Address && (c.Address.Street || c.Address.City)) ? c.Address : m.Address;
			const bank = (c.BankDetails && (c.BankDetails.BankName || c.BankDetails.IBAN)) ? c.BankDetails : m.BankDetails;
			return {
				Name: c.Name || m.Name,
				Type: c.Type || m.Type,
				isMain: !!c.isMain,
				InternalName: c.InternalName || m.InternalName,
				Logo: c.Logo || m.Logo,
				LogoName: c.LogoName || m.LogoName,
				LogoPosition: c.LogoPosition || m.LogoPosition,
				Address: addr,
				Phone: c.Phone || m.Phone,
				Fax: c.Fax,
				Email: c.Email || m.Email,
				Site: c.Site || m.Site,
				Owners: c.Owners || m.Owners,
				Registration: c.Registration || m.Registration,
				TaxNumber: c.TaxNumber || m.TaxNumber,
				BankDetails: bank,
			};
		}
	},
	methods: {
		loadProposal(id) {
			this.$store.dispatch('getProposal', id);
		},
		backToBuilder() {
			router.push({
				name: 'Builder',
				params: {
					proposal: this.proposal
				},
				query: {
					proposal: this.proposal.id
				}
			})
		},
		printPage() {
			window.print();
		},
		toggleButton() {
			const state = {
				draft: 'pending',
				pending: 'accepted',
				accepted: 'updated',
                updated: 'rejected',
				rejected: 'draft'
			};
			this.proposal['Status'] = state[this.proposal['Status']] || false;
			this.$store.dispatch('updateProjectInfo', this.proposal);
		}
	},
	mounted() {
		this.loadProposal(this.$route.query.proposal);

		setTimeout(() => {
			this.isLoading = false;
		}, 2000);
	}
}
</script>

<style lang="scss">
body {
    background-color: color(bg);
    &::before {
        display: none !important;
    }
}
.Proposal{
	.Navigation {
	    top: 5px;
	    left: 0;
	    position: fixed;
	    z-index: zIndex(navigation);
	    height: 100%;
	    padding-right: 15px;
	    box-sizing: border-box;
	    padding: 50px 50px 65px;
	    width: 300px;
	    //border-right: solid 2px color(second);
	    display: flex;
	    flex-direction: column;
	    justify-content: space-between;

	    .Button {
	        text-align: center;
	        width: 180px;
	    }
	}
}

.Wrapper {
    padding: 40px;
}

@media print {
    body,
    html {
        width: 210mm;
        height: 297mm;
        background-color: transparent;
        -webkit-print-color-adjust: exact;
        &::after,
        &::before {
            display: none !important;
        }
        .Navigation {
            display: none !important;;
        }
        .Page {
            margin: 0;
            box-shadow: none;
        }
        .Wrapper {
            padding: 0;
        }
    }
}
.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.75s;
}
/* .fade-leave-active below version 2.1.8 */
.fade-enter,
.fade-leave-to {
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// Proposal.vue?255f7892